import React, { useEffect, useRef } from 'react';
import './AboutUs.css';

function useReveal(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const els = ref.current.querySelectorAll('.reveal');
    const obs = new IntersectionObserver(
      (entries) => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); }),
      { threshold: 0.15 }
    );
    els.forEach(el => obs.observe(el));
    return () => obs.disconnect();
  }, [ref]);
}

function AboutUs() {
  const rootRef = useRef(null);
  useReveal(rootRef);

  return (
    <div id="über-uns" className="aboutus-root" ref={rootRef}>

      {/* ── Intro ── */}
      <section className="au-section au-intro">
        <div className="au-inner">
          <span className="au-eyebrow reveal">EG-Bau · Hannover</span>
          <h1 className="au-title reveal">Über<br /><em>uns</em></h1>
          <div className="au-divider reveal" />
          <p className="au-body reveal">
            EG-Bau ist ein wachsendes Dienstleistungsunternehmen im Bereich Garten- und
            Landschaftsbau mit Sitz in der Region Hannover. Unsere Stärke liegt in der
            Kombination aus Erfahrung, handwerklichem Geschick und echter Leidenschaft
            für das, was wir tun. Jedes Projekt wird individuell geplant und umgesetzt —
            damit Ihr Außenbereich das wird, was er verdient: ein echtes Zuhause.
          </p>
        </div>
        <div className="au-deco-number reveal" aria-hidden>01</div>
      </section>

      {/* ── Was uns auszeichnet ── */}
      <section className="au-section au-feature">
        <div className="au-inner au-inner--split">
          <div className="au-split-label reveal">
            <span className="au-eyebrow">Was uns auszeichnet</span>
            <div className="au-deco-number au-deco-number--inline" aria-hidden>02</div>
          </div>
          <div className="au-split-body">
            <h2 className="au-heading reveal">Qualität, die<br /><em>bleibt</em></h2>
            <p className="au-body reveal">
              Wir glauben daran, dass ein schöner Garten nicht nur die Lebensqualität
              steigert, sondern auch Verantwortung für die Umwelt bedeutet. Deshalb
              setzen wir auf langlebige Materialien und umweltbewusste Lösungen.
              Team-intern setzen wir auf kontinuierliche Weiterentwicklung durch
              konstruktive Feedbackgespräche — um das Beste aus jedem Projekt rauszuholen.
            </p>
            <ul className="au-pills reveal">
              {['Langlebige Materialien', 'Umweltbewusst', 'Offene Kommunikation', 'Individuell geplant'].map(t => (
                <li key={t}>{t}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* ── Geschichte ── */}
      <section className="au-section au-history">
        <div className="au-inner">
          <span className="au-eyebrow reveal">Unsere Geschichte</span>
          <h2 className="au-heading reveal">Kleider machen Leute —<br /><em>Gärten machen Häuser zu Zuhause</em></h2>
          <div className="au-divider reveal" />
          <p className="au-body reveal">
            Schon im jungen Alter erkannten wir, wie wichtig professionelle
            Garten- und Landschaftsbauarbeit ist. Leider sparen viele an den
            falschen Ecken. Das Auge isst mit — und das auch, wenn es aus dem
            Fenster ins Grüne blickt.
          </p>
        </div>
        <div className="au-deco-number reveal" aria-hidden>03</div>
      </section>

      {/* ── Ziel ── */}
      <section className="au-section au-goal">
        <div className="au-inner au-inner--split">
          <div className="au-split-label reveal">
            <span className="au-eyebrow">Unser Ziel</span>
            <div className="au-deco-number au-deco-number--inline" aria-hidden>04</div>
          </div>
          <div className="au-split-body">
            <h2 className="au-heading reveal">Nachhaltig.<br /><em>Pflegeleicht. Schön.</em></h2>
            <p className="au-body reveal">
              Unser Ziel ist es, nachhaltige, pflegeleichte und optisch ansprechende
              Gartenlandschaften zu schaffen, die zu einer höheren Lebensqualität und
              einer besseren Umwelt beitragen. Sind unsere Kunden zufrieden, so sind
              auch wir es.
            </p>
            <a href="#contact" className="au-cta reveal">Jetzt Anfrage stellen</a>
          </div>
        </div>
      </section>

    </div>
  );
}

export default AboutUs;